import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import { ZeeFontBold } from 'src/styles/font';

export const toastMessage = css`
  ${ZeeFontBold(14, 18)};
  border: 1px solid ${colors.black};
  background-color: ${colors.AccentCodGrayColor};
  color: ${colors.white};
  border-radius: 3px;
  padding: 16px;
  animation: moveitback 0.7s ease forwards;
  will-change: transform;
  margin: 0 auto;
  text-align: center;
  width: fit-content;
  max-width: 250px;
  min-width: 100px;
  @keyframes moveitback {
    0% {
      transform: translateY(60px);
    }

    100% {
      transform: translateY(0) scale3d(0.96, 0.96, 1);
    }
  }
`;
export const toastContainer = css`
  position: fixed;
  bottom: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  z-index: 2000;
`;
